export type ClientCenterServerContext = {
  cid?: string,
  aid?: string,
  smallAuthToken?: string,
  currentUser: object,
};

export type CampaignServerContext = {
  Token?: string,
  CurrentAccount?: {
    Id?: number,
    AdvertiserCustomerID?: number,
  },
  CurrentCustomer?: {
    Id: number,
  },
};

/**
 * Convert any server context received from CCUI components to the typical format we usually get in CMUI.
 * @param serverContext - The server context object.
 * @returns ServerContext in the CMUI format.
 */
export function convertToCampaignServerContext(serverContext: any): CampaignServerContext | undefined {
  if (serverContext) {
    const campaignServerContext = serverContext as CampaignServerContext;
    if (campaignServerContext.CurrentCustomer || campaignServerContext.CurrentAccount) {
      return campaignServerContext;
    }

    const clientCenterServerContext = serverContext as ClientCenterServerContext;
    if (clientCenterServerContext.cid || clientCenterServerContext.currentUser) {
      return {
        Token: clientCenterServerContext.smallAuthToken,
        CurrentCustomer: {
          Id: clientCenterServerContext.cid && parseInt(clientCenterServerContext.cid, 10),
        },
        CurrentAccount: {
          Id: clientCenterServerContext.aid && parseInt(clientCenterServerContext.aid, 10),
          AdvertiserCustomerID: clientCenterServerContext.cid && parseInt(clientCenterServerContext.cid, 10),
        },
      };
    }
  }

  return undefined;
}
